import moment from "moment";
import useLatestBuild from "src/hooks/useCurrentVersion";
import useModules from "src/hooks/selectors/useModules";
import useAuth from "src/hooks/selectors/useAuth";
import Container from "src/components/layout/Container";

const LayoutFooter = () => {
	const currentVersion = useLatestBuild();
	const { modules } = useModules();
	const auth = useAuth();

	if (auth.type === "company") {
		return <></>;
	}

	return (
		<Container className="hidden md:flex py-8 justify-between items-center gap-4 w-full text-dark dark:text-white">
			<small className="updated_at flex-1 font-[8px] opacity-0">
				{moment(currentVersion).format("DD-MM-YYYY")}
			</small>
			<small className="flex flex-col flex-1 justify-center font-[8px] items-center">
				{process.env.NODE_ENV === "development" && (
					<span>{modules.join(",")}</span>
				)}

				{process.env.NODE_ENV === "development" && (
					<div className="flex justify-center items-center flex-col">
						<p>
							<strong>User ID:</strong> {auth.id}
						</p>
						{auth.type === "student" && (
							<p>
								<strong>Merchant id:</strong> {auth.merchant_id}
							</p>
						)}
					</div>
				)}
			</small>
			<div className="flex-1" />
		</Container>
	);
};

export default LayoutFooter;
